import { LocalAtRecord } from '../../db';
import { BoxesFieldSet } from '@rogoag/airtable/crm';

/**
 * Client-side guard mirroring the Airtable view filters for "Boxes Ready for Shipping".
 * Defends against data bugs (e.g. recovery-file-processor setting Closed=true without timestamp).
 */
export function filterBoxesReadyForShipping(boxes: LocalAtRecord<BoxesFieldSet>[]): LocalAtRecord<BoxesFieldSet>[] {
  return boxes.filter((box) => box.get('Closed') && box.get('Closed Timestamp') && !box.get('Ship Date'));
}
